import React, {useState, useContext} from 'react'
import { GlobalContext } from '../context/GlobalState';

export const AddTransaction = () => {
  const [text, setText] = useState('');
  const [amount, setAmount] = useState(0);

  const { addTransaction } = useContext(GlobalContext);

  const onSubmit = e => {
    e.preventDefault();

    const newTransaction = {
      id: Math.floor(Math.random() * 100000000),
      text,
      amount: +amount
    }

    addTransaction(newTransaction);
  }

  return (
    <>
    <div className="listTitleExpenser">
      <h3>取引を追加</h3></div>
      <form onSubmit={onSubmit}>
        <div className="">
          <label htmlFor="text">取引項目</label>
          <input type="text" value={text} onChange={(e) => setText(e.target.value)} placeholder="ここに取引項目を入力してください..." />
        </div>
        <div className="">
          <label htmlFor="amount"
            >金額合計 <br />
            (マイナス - 支出, プラス - 収入)</label
          >
          <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="金額を入力してください..." />
        </div>
        <button className="btn">追加！</button>
      </form>
    </>
  )
}
